import PropTypes from 'prop-types'
import { Box, Heading, HStack, Text, VStack } from '@chakra-ui/react'
import React from 'react'
import { useLabels } from '../../../../utils/hooks/useLabels/useLabels'
import { colors } from '../../../../utils/theme/styles'
import InfoLabel from '../../../EmployeeDetails/components/InfoLabel'
import { ItemWrapper } from './CompanyInfo'

export default function BabyRoomInfo({ data }) {
  const { texts } = useLabels()
  return (
    <VStack spacing="20px" w="100%" alignItems="flex-start">
      <Box>
        <Heading color={colors.gray[800]} variant="h6">
          {texts.baby_room_information}
        </Heading>
      </Box>

      <VStack w="100%" alignItems="flex-start">
        <ItemWrapper>
          <InfoLabel
            title={texts.operational_interlocutor}
            value={data.sNombreAsesorSalaCuna}
          />
        </ItemWrapper>
        <HStack
          w="100%"
          justifyContent="flex-start"
          alignItems="center"
          wrap="wrap"
        >
          <ItemWrapper>
            <InfoLabel
              title={texts.operative_partner_email}
              value={data.sEmailFacturaSalaCuna}
            />
          </ItemWrapper>
          <Text textDecor="underline" cursor="pointer" variant="caption1">
            {texts.view_email}
          </Text>
        </HStack>
        <HStack
          w="100%"
          justifyContent="flex-start"
          alignItems="center"
          wrap="wrap"
        >
          <ItemWrapper>
            <InfoLabel
              title={texts.email_billing}
              value={data.sEmailFacturaSalaCuna}
            />
          </ItemWrapper>
          <Text textDecor="underline" cursor="pointer" variant="caption1">
            {texts.view_emailf}
          </Text>
        </HStack>
      </VStack>
    </VStack>
  )
}

BabyRoomInfo.propTypes = {
  data: PropTypes.shape({
    sEmailFacturaSalaCuna: PropTypes.string,
    sNombreAsesorSalaCuna: PropTypes.string,
  }),
}
